/** @format */

import React, { useRef, useState } from 'react';
import style from '../css/HeaderForm.module.css';
import Select, { components } from 'react-select';

// import emailjs from '@emailjs/browser';
// import Swal from 'sweetalert2';
// import ReCAPTCHA from 'react-google-recaptcha';

// import { SiZoom, SiWhatsapp } from 'react-icons/si';
import { MdPlayArrow } from 'react-icons/md';

import paises, { paises2, cursos } from '../utils/paises';
import profile, { software, inversion } from '../utils/options';

import VideoModal from './modals/VideoModal';

import personaje from '../images/header_form.png';
import logo from '../images/logo_dot.png';

const HeaderForm = () => {
	const captcha = useRef(null);
	const [openModal, setOpenModal] = useState(false);
	const [formularioEnviado, setFormularioEnviado] = useState(false);

	const [templateParams, setTemplateParams] = useState({
		FIRSTNAME: '',
		// LASTNAME: '',
		CONTACT_EMAIL: '',
		Country: '',
		Phone: '',
		LEADCF14: '', //Profile
		LEADCF13: [{}], //Software
		LEADCF5: '', //PC
		LEADCF4: '', //Area
		LEADCF21: '', //Inversion
	});

	// const serviceID = 'service_t4ltjhw';
	// const templateID = 'template_nekhiqv';
	// const publicKey = 'DCgvpZvEmo1MaZGx-';

	const handlerClose = () => {
		setOpenModal(false);
	};

	const handlerSubmit = (event) => {
		event.preventDefault();
		if (formularioEnviado) {
			return;
		}
		setFormularioEnviado(true);

		// emailjs
		// 	.send(serviceID, templateID, templateParams, publicKey)
		// 	.then((res) => {
		// 		console.log('Datos enviados correctamente', res);
		// 		setTemplateParams({
		// 			FIRSTNAME: '',
		// 			// LASTNAME: '',
		// 			CONTACT_EMAIL: '',
		// 			COUNTRY: '',
		// 			CONTACT_CF16: '',
		// 			PHONE: '',
		// 			CONTACT_CF3: '',
		// 		});
		// 		Swal.fire({
		// 			title: '¡Enviado!',
		// 			text: 'Tus datos se han envíado satisfactoriamente',
		// 			icon: 'success',
		// 			confirmButtonText: 'Aceptar',
		// 		});
		// 	})
		// 	.catch((err) =>
		// 		Swal.fire({
		// 			title: 'Error',
		// 			text: 'Error al envíar los datos',
		// 			icon: 'error',
		// 			confirmButtonText: 'Aceptar',
		// 		})
		// 	);

		// if (form.querySelector('#zc_spmSubmit')) {
		// 	form.querySelector('#zc_spmSubmit').remove();
		// }
		// form.submit();

		// setTemplateParams({
		// 	FIRSTNAME: '',
		// 	// LASTNAME: '',
		// 	CONTACT_EMAIL: '',
		// 	COUNTRY: '',
		// 	CONTACT_CF16: '',
		// 	PHONE: '',
		// 	CONTACT_CF3: '',
		// });

		setTimeout(() => {
			setFormularioEnviado(false);
		}, 2000);
	};

	const handlerChange = (event) => {
		const nameProp = event.target.name;
		let valueProp = event.target.value;
		setTemplateParams({ ...templateParams, [nameProp]: valueProp });
	};

	const handlerCountrySelect = (event) => {
		const valueProp = event.target.value;
		const paisActual = paises.find((e) => e.nombre === valueProp);

		if (paisActual) {
			setTemplateParams({
				...templateParams,
				Country: paisActual.nombre,
				Phone: paisActual.ind,
			});
		}
	};

	const handlerCountrySelect2 = (event) => {
		const name = event.label;
		const ind = event.ind;

		setTemplateParams({
			...templateParams,
			Country: name,
			Phone: ind,
		});
	};

	// function handlerReCAPTCHA(value) {
	// 	console.log('usuario verificado');
	// }

	const IconOption = (props) => {
		return (
			<components.Option {...props}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={props.data.img}
						alt={`Bandera de ${props.data.label}`}
						style={{
							width: '25px',
							height: 'auto',
							marginRight: '10px',
							borderRadius: '2px',
							objectFit: 'cover',
						}}
					/>
					<span style={{ fontSize: '14px', color: '#333' }}>
						<span style={{ color: '#888', marginLeft: '5px' }}>{props.data.value}</span>
					</span>
				</div>
			</components.Option>
		);
	};

	const SingleValue = (props) => {
		return (
			<components.SingleValue {...props}>
				<div value={props.data.label} style={{ display: 'flex', alignItems: 'center' }}>
					<img
						src={props.data.img}
						alt={`Bandera de ${props.data.label}`}
						style={{
							width: '20px',
							height: 'auto',
							marginRight: '8px',
							borderRadius: '2px',
							objectFit: 'cover',
						}}
					/>
					<span style={{ fontSize: '14px', fontWeight: '500' }}>{props.data.value}</span>
				</div>
			</components.SingleValue>
		);
	};

	return (
		<section className={style.header} id='home'>
			<div className={style.containerMain}>
				<div className={style.headerContainer}>
					<div className={style.headerContent}>
						<div className={style.burbuja}>
							<div>
								<img src={logo} alt='logo-libel' />
							</div>
							<h3>
								<b> Certificación</b> Universitaria
							</h3>
						</div>
						<h1 className={style.headerTitle}>
							CLASES ONLINE
							<br />
							100% en{' '}
							<span>
								VIVO
								{/* <img
									src='https://react-bitakon.netlify.app/assets/img/icon/slider-stoke-shape.svg'
									alt='line'
									className={style.headerLine}
								/> */}
							</span>
						</h1>

						<p>
							Inicia hoy tu entrenamiento online en vivo desde cualquier parte del mundo, te
							llevamos de cero a niveles avanzados.
						</p>
						<div className={style.headerButtons}>
							{/* <a
								// className='header-button degrade'
								className={`${style.headerButton} ${style.degrade}`}
								href='#contenido'
								// target={'_blank'}
								// rel='noreferrer'
							> */}
							{/* <SiWhatsapp style={{ fontSize: 20, marginRight: 10 }} /> */}
							{/* Ver más
							</a> */}
							<a
								// className={style.headerButton2}
								className={`${style.headerButton} ${style.degrade}`}
								onClick={() => setOpenModal(true)}
								// href='https://libel.academy/asesoria/'
								// target={'_blank'}
								rel='noreferrer'
							>
								<div className={style.buttonPlay}>
									<MdPlayArrow style={{ fontSize: 28, marginRight: '6px' }} />
								</div>
								Ver video
							</a>
						</div>
					</div>
				</div>

				{/* <div className={style.imgPersonajeContainer}>
					<img src={personaje} alt='personaje zbrush' />
				</div> */}

				<div className={style.containerForm} id='form'>
					<h1>
						Inicia tu proceso de <span>admisión</span>
					</h1>
					<h2>Nuestro equipo evaluará tu perfil</h2>
					<form
						id='webform4793673000069018051'
						action='https://crm.zoho.com/crm/WebToLeadForm'
						name='WebToLeads4793673000069018051'
						method='POST'
						acceptCharset='UTF-8'
					>
						<input
							type='text'
							style={{ display: 'none' }}
							name='xnQsjsdp'
							value='87989784edd6307355a0bce3ef1148b79dad6e0c293c81983ab5e2ddbab84bce'
						></input>
						<input type='hidden' name='zc_gad' id='zc_gad' value=''></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='xmIwtLD'
							value='71761690d9f130f27ee720abbe6a40c363cc467d4e5576a34fb7c96fc38e582be1f11b30814ba3c8a04e6488a5ef596e'
						></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='actionType'
							value='TGVhZHM='
						></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='returnURL'
							value='https&#x3a;&#x2f;&#x2f;www.libel.academy&#x2f;zimpresion'
						></input>
						{/* ------------------------------------------------------- */}
						<div className={style.orderForm}>
							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='Last_Name'>
										Nombre Completo<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<input
										type='text'
										id='Last_Name'
										name='Last Name'
										placeholder='Tu nombre completo'
										autoComplete='off'
										maxLength='30'
										required
									></input>
								</div>
							</div>

							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='Email'>
										Correo electrónico<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<input
										type='text'
										ftype='email'
										id='Email'
										autoComplete='off'
										placeholder='ejemplo@correo.com'
										name='Email'
										crmlabel=''
										maxLength='100'
										required
									></input>
									<div className='zcwf_col_help'></div>
								</div>
							</div>
						</div>
						<div className={style.orderForm}>
							<div className={style.containerInputMainCounty} style={{ zIndex: '3' }}>
								<div className={style.titleInput} style={{ zIndex: '4' }}>
									<label htmlFor='Country'>
										País<span style={{ color: 'red' }}>*</span>
									</label>
								</div>

								<Select
									styles={{
										control: (baseStyles, state) => ({
											...baseStyles,
											backgroundColor: state.isFocused ? '#05092b' : 'trasnparent',
											borderRadius: '10px',
											border:
												state.isFocused || state.hasValue ? '1px solid #6000de' : '1px solid white',

											boxShadow: 'none',
											'&:hover': {
												border: 'auto',
											},
											cursor: 'pointer',
											transition: 'all 0.3s ease-in-out',
											minHeight: '50px',
										}),
										placeholder: (styles, state) => ({
											...styles,
											fontSize: '12px',
											fontFamily: 'Be Vietnam Pro',
											color: '#9e9e9e',
											paddingLeft: '9px',
											// margin: '0px',
											// padding: '0',
										}),

										valueContainer: (base, state) => {
											const hasValue = state.selectProps.value?.length > 1;
											return {
												...base,
												padding: '0 15px', // Alineación del texto interno
												paddingTop: hasValue ? '12px' : '0px',
											};
										},
										singleValue: (base) => ({
											...base,
											color: 'white',
										}),
										multiValue: (base) => ({
											...base,
											backgroundColor: '#ffffff20', // Fondo de las etiquetas seleccionadas
											borderRadius: '4px',
										}),
										multiValueLabel: (base) => ({
											...base,
											color: 'white',
										}),
										multiValueRemove: (base) => ({
											...base,
											color: 'white',
											'&:hover': {
												backgroundColor: 'red',
												color: 'white',
											},
										}),
										indicatorSeparator: () => ({
											display: 'none', // Quita la línea vertical al lado de la flecha
										}),
										menu: (base) => ({
											...base,
											backgroundColor: '#05092b', // Color de fondo de la lista desplegable
										}),
										option: (base, state) => ({
											...base,
											backgroundColor: state.isFocused ? '#ffffff20' : 'transparent',
											color: 'white',
										}),
										dropdownIndicator: (base, state) => ({
											...base,
											color: state.isFocused ? '#6000de' : 'white', // Morado si está activo
											transition: 'all 0.3s ease-in-out',
										}),
									}}
									onChange={handlerCountrySelect2}
									// id='Country'
									// name='Country'
									// value={templateParams.Country}
									options={paises2}
									required
									components={{
										Option: IconOption, // Reemplazamos el componente Option
										SingleValue: SingleValue, // Reemplazamos el componente SingleValue
									}}
									placeholder='Elige'
								/>
							</div>
							<input type='hidden' name='Country' id='Country' value={templateParams.Country} />

							<div className={style.containerInputMain} style={{ maxWidth: '206px' }}>
								<div className={style.titleInput}>
									<label htmlFor='Phone'>
										Celular<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<input
										type='text'
										id='Phone'
										name='Phone'
										placeholder='+00 0000000000'
										onChange={handlerChange}
										value={templateParams.Phone}
										autoComplete='off'
										maxLength='20'
										required
									></input>
								</div>
							</div>

							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='LEADCF14'>
										Perfil profesional<span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<select
										className={templateParams.LEADCF14 ? style.selected : style.noSelected}
										onChange={handlerChange}
										value={templateParams.LEADCF14 ? templateParams.LEADCF14 : ''}
										id='LEADCF14'
										name='LEADCF14'
										type='text'
										required
									>
										<option hidden={true} value=''>
											Selecciona tu perfil
										</option>

										{profile.map((profile, i) => (
											<option key={i} value={profile}>
												{profile}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className={style.orderForm}>
							<div className={style.containerInputMainMulti}>
								<div className={style.titleInputMulti}>
									<label htmlFor='LEADCF13'>
										Software que utilizas<span style={{ color: 'red' }}>*</span>
									</label>
								</div>

								<Select
									styles={{
										control: (baseStyles, state) => ({
											...baseStyles,
											backgroundColor: state.isFocused ? '#05092b' : 'trasnparent',
											borderRadius: '10px',
											border: state.isFocused ? '1px solid #6000de' : '1px solid white',

											boxShadow: 'none',
											'&:hover': {
												border: 'auto',
											},
											cursor: 'pointer',
											transition: 'all 0.3s ease-in-out',
											minHeight: '50px',
										}),
										placeholder: (styles, state) => ({
											...styles,
											fontSize: '12px',
											fontFamily: 'Be Vietnam Pro',
											color: '#9e9e9e',
											paddingLeft: '9px',
										}),

										valueContainer: (base, state) => {
											const hasValue = state.selectProps.value?.length > 1;
											return {
												...base,
												padding: '0 15px', // Alineación del texto interno
												paddingTop: hasValue ? '12px' : '0px',
											};
										},
										singleValue: (base) => ({
											...base,
											color: 'white',
										}),
										multiValue: (base) => ({
											...base,
											backgroundColor: '#ffffff20', // Fondo de las etiquetas seleccionadas
											borderRadius: '4px',
										}),
										multiValueLabel: (base) => ({
											...base,
											color: 'white',
										}),
										multiValueRemove: (base) => ({
											...base,
											color: 'white',
											'&:hover': {
												backgroundColor: 'red',
												color: 'white',
											},
										}),
										indicatorSeparator: () => ({
											display: 'none', // Quita la línea vertical al lado de la flecha
										}),
										menu: (base) => ({
											...base,
											backgroundColor: '#05092b', // Color de fondo de la lista desplegable
										}),
										option: (base, state) => ({
											...base,
											backgroundColor: state.isFocused ? '#ffffff20' : 'transparent',
											color: 'white',
										}),
										dropdownIndicator: (base, state) => ({
											...base,
											color: state.isFocused ? '#6000de' : 'white', // Morado si está activo
											transition: 'all 0.3s ease-in-out',
										}),
									}}
									isMulti
									id='LEADCF13'
									name='LEADCF13'
									options={software}
									placeholder='Selecciona los software'
									required
								/>
							</div>

							<div className={style.containerInputMain}>
								<div className={style.titleInput}>
									<label htmlFor='LEADCF21'>
										Perfil de inversión <span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.inputContainer}>
									<select
										className={templateParams.LEADCF21 ? style.selected : style.noSelected}
										onChange={handlerChange}
										value={templateParams.LEADCF21 ? templateParams.LEADCF21 : ''}
										id='LEADCF21'
										name='LEADCF21'
										type='text'
										required
									>
										<option hidden={true} value=''>
											Selecciona tu rango de inversión
										</option>

										{inversion.map((e, i) => (
											<option key={i} value={e}>
												{e}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className={style.orderForm}>
							<div className={style.containerTextAreaMain}>
								<div className={style.titleTextArea}>
									<label htmlFor='LEADCF5'>
										Caracteristicas de tu equipo <span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.textAreaContainer}>
									<textarea
										id='LEADCF5'
										name='LEADCF5'
										placeholder='Procesador, RAM, Tarjeta de video'
										required
										maxLength='255'
									></textarea>
								</div>
							</div>

							<div className={style.containerTextAreaMain}>
								<div className={style.titleTextArea}>
									<label htmlFor='LEADCF4'>
										Área de especialización <span style={{ color: 'red' }}>*</span>
									</label>
								</div>
								<div className={style.textAreaContainer}>
									<textarea
										id='LEADCF4'
										name='LEADCF4'
										placeholder='Objetivo profesional'
										required
										maxLength='255'
									></textarea>
								</div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='Lead_Source'>Fuente de Posible cliente</label>
							</div>
							<div class='zcwf_col_fld'>
								<select class='zcwf_col_fld_slt' id='Lead_Source' name='Lead Source'>
									<option value='-None-'>-None-</option>
									<option value='WhatsApp'>WhatsApp</option>
									<option value='Facebook'>Facebook</option>
									<option value='Instagram'>Instagram</option>
									<option value='Calendly'>Calendly</option>
									<option value='Formulario&#x20;web&#x20;home'>Formulario web home</option>
									<option selected value='Formulario&#x20;web&#x20;m&aacute;ster'>
										Formulario web m&aacute;ster
									</option>
									<option value='Correo'>Correo</option>
									<option value='Importaci&oacute;n'>Importaci&oacute;n</option>
									<option value='Feria&#x20;del&#x20;Libro'>Feria del Libro</option>
									<option value='Curso&#x20;gratuito'>Curso gratuito</option>
									<option value='Evento&#x20;Presencial&#x20;24&#x20;agosto'>
										Evento Presencial 24 agosto
									</option>
								</select>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='LEADCF10'>Asesor</label>
							</div>
							<div class='zcwf_col_fld'>
								<select class='zcwf_col_fld_slt' id='LEADCF10' name='LEADCF10'>
									<option value='-None-'>-None-</option>
									<option value='Gilberto'>Gilberto</option>
									<option value='Juieth'>Juieth</option>
									<option value='Katherine'>Katherine</option>
									<option value='Natalia'>Natalia</option>
									<option value='Sonia'>Sonia</option>
									<option value='Viviana'>Viviana</option>
									<option selected value='Otro'>
										Otro
									</option>
								</select>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='LEADCF12'>Formulario de Ads</label>
							</div>
							<div class='zcwf_col_fld'>
								<input
									type='text'
									id='LEADCF12'
									name='LEADCF12'
									maxlength='255'
									value='M&aacute;ster&#x20;en&#x20;ZBrush'
								></input>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<div className={style.reCaptchaContainer}>
								<label className={style.checkBox}>
									<input type='checkbox' id='cbox1' value='first_checkbox' required /> Acepto
									las&nbsp;
									<a href='https://libel.academy/politicas-de-privacidad/' target={'_blank'}>
										políticas de privacidad
									</a>
								</label>
							</div>
							<input
								className={formularioEnviado ? style.buttonSubmitDisable : style.buttonSubmit}
								disabled={formularioEnviado}
								type='submit'
								id='formsubmit'
								value='Enviar Solicitud'
								title='Enviar'
							/>

							{/* <input
								type='reset'
								class='zcwf_button'
								name='reset'
								value='Restablecer'
								title='Restablecer'
							/> */}
						</div>
						<script
							id='wf_anal'
							src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=cef2bd2d87743441117ce925a79765a812cd912dfacf16b82cac5a9df886130c08a5138403e27b4ca41a354d15e88cb0gidf8eca932838edbcb4ff46c4af30b6e8d9f7c91ac377f15cbdd3df45afdb89fbcgid587dc3eb526de219833b06851bc1e36e2d4deb87863cfa2018b74b3238938a3fgid3300670d3ee4732783fab54e8b6f932864177e3e8b10c9f26e52084215ec10dc&tw=f56d14583d1f3fcb5abdf9c4c09f43343d02b73c32b9ae02be2c70db609359a8'
						></script>
					</form>
					{/* <form
						method='POST'
						id='zcampaignOptinForm'
						action='https://bpxez-zgph.maillist-manage.net/weboptin.zc'
						target='_blank'
						onSubmit={handlerSubmit}
					>
						<div id='SIGNUP_BODY_ALL' name='SIGNUP_BODY_ALL'>
							<div id='SIGNUP_BODY' name='SIGNUP_BODY'>
								<div className={style.containerZoho}>
									<div className={style.containerInputMain}>
										<div name='SIGNUP_FORM_LABEL' className={style.titleInput}>
											<label>
												Nombre completo
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className={style.inputContainer}>
											<input
												onChange={handlerChange}
												type='text'
												name='FIRSTNAME'
												changeitem='SIGNUP_FORM_FIELD'
												value={templateParams.FIRSTNAME}
												placeholder='Tu nombre completo'
												autoComplete='off'
												maxLength='30'
												required
											/>
										</div>
									</div>

									<div className='container-input-main'>
										<div name='SIGNUP_FORM_LABEL' className='title-input'>
											<label>
												Email
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className='input-container'>
											<input
												onChange={handlerChange}
												value={templateParams.CONTACT_EMAIL}
												type='email'
												name='CONTACT_EMAIL'
												changeitem='SIGNUP_FORM_FIELD'
												placeholder='Ingresa tu email'
												autoComplete='off'
												maxLength='50'
												required
											/>
										</div>
									</div>

									<div className='container-input-main'>
										<div name='SIGNUP_FORM_LABEL' className='title-input'>
											<label>
												País
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className='input-container'>
											<select
												className={templateParams.COUNTRY ? 'selected' : 'no-selected'}
												onChange={handlerCountrySelect}
												value={templateParams.COUNTRY ? templateParams.COUNTRY : ''}
												changeitem='SIGNUP_FORM_FIELD'
												name='COUNTRY'
												type='text'
												required
											>
												<option hidden={true} value=''>
													Selecciona el país
												</option>

												{paises.map((pais, i) => (
													<option key={i} value={pais.nombre}>
														{pais.nombre}
													</option>
												))}
											</select>
										</div>
									</div>

									<div className='inputs-phone'>
										<div className='container-input-main-ind'>
											<div name='SIGNUP_FORM_LABEL' className='title-input'>
												<label>
													Ind
													<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
														{' '}
														*
													</span>
												</label>
											</div>
											<div className='input-container-ind'>
												<input
													onChange={handlerChange}
													value={templateParams.CONTACT_CF16}
													type='text'
													name='CONTACT_CF16'
													changeitem='SIGNUP_FORM_FIELD'
													placeholder='ej: +57'
													autoComplete='off'
													maxLength='10'
													required
												/>
											</div>
										</div>

										<div className='container-input-main-cel'>
											<div name='SIGNUP_FORM_LABEL' className='title-input'>
												<label>
													Celular
													<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
														{' '}
														*
													</span>
												</label>
											</div>
											<div className='input-container-cel'>
												<input
													onChange={handlerChange}
													value={templateParams.PHONE}
													type='number'
													name='PHONE'
													changeitem='SIGNUP_FORM_FIELD'
													placeholder='ej: 3101010203'
													autoComplete='off'
													maxLength='50'
													required
												/>
											</div>
										</div>
									</div>

									<div className='container-input-main'>
										<div name='SIGNUP_FORM_LABEL' className='title-input'>
											<label>
												Solicitud
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className='input-container'>
											<select
												className={templateParams.CONTACT_CF3 ? 'selected' : 'no-selected'}
												onChange={handlerChange}
												value={templateParams.CONTACT_CF3 ? templateParams.CONTACT_CF3 : ''}
												type='text'
												name='CONTACT_CF3'
												changeitem='SIGNUP_FORM_FIELD'
												required
											>
												<option hidden={true} value='' style={{ color: 'red' }}>
													Selecciona el entrenamiento
												</option>

												{cursos.map((curso, i) => (
													<option key={i} value={curso.nombre}>
														{curso.nombre}
													</option>
												))}
											</select>
										</div>
									</div>

									<div style={{ display: 'none' }} ishidden='true'>
										<div>
											<div name='SIGNUP_FORM_LABEL'>Asesor&nbsp;</div>
											<div class='zcinputbox'>
												<input
													name='CONTACT_CF4'
													changeitem='SIGNUP_FORM_FIELD'
													maxlength='100'
													type='text'
													value='Viviana'
												/>
											</div>
										</div>
									</div>

									<div style={{ display: 'none' }} ishidden='true'>
										<div>
											<div name='SIGNUP_FORM_LABEL'>Fuente de posible cliente&nbsp;</div>
											<div class='zcinputbox'>
												<input
													name='CONTACT_CF5'
													changeitem='SIGNUP_FORM_FIELD'
													maxlength='100'
													type='text'
													value='Formulario web masters'
												/>
											</div>
										</div>
									</div>
								</div>

								<div className={style.reCaptchaContainer}>
									<label className={style.checkBox}>
										<input type='checkbox' id='cbox1' value='first_checkbox' required /> Acepto
										las&nbsp;
										<a href='https://libel.academy/politicas-de-privacidad/' target={'_blank'}>
											políticas de privacidad
										</a>
									</label>
								</div>

								<input
									type='hidden'
									id='secretid'
									value='6LdNeDUUAAAAAG5l7cJfv1AA5OKLslkrOa_xXxLs'
								/>
								<div></div>

								<div>
									<input
										className={formularioEnviado ? style.buttonSubmitDisable : style.buttonSubmit}
										disabled={formularioEnviado}
										type='submit'
										action='Save'
										id='zcWebOptin'
										name='SIGNUP_SUBMIT_BUTTON'
										changetype='SIGNUP_SUBMIT_BUTTON_TEXT'
										value='Enviar Solicitud'
									/>
								</div>
							</div>

							<input type='hidden' id='fieldBorder' value='' onload='' />
							<input
								type='hidden'
								name='zc_trackCode'
								id='zc_trackCode'
								value='ZCFORMVIEW'
								onload=''
							/>
							<input type='hidden' name='viewFrom' id='viewFrom' value='URL_ACTION' />
							<input type='hidden' id='submitType' name='submitType' value='optinCustomView' />
							<input type='hidden' id='lD' name='lD' value='1bb1b38789cb8a3f' />
							<input type='hidden' name='emailReportId' id='emailReportId' value='' />
							<input type='hidden' name='zx' id='cmpZuid' value='12c2f37a7' />
							<input type='hidden' name='zcvers' value='3.0' />
							<input type='hidden' name='oldListIds' id='allCheckedListIds' value='' />
							<input type='hidden' id='mode' name='mode' value='OptinCreateView' />
							<input type='hidden' id='zcld' name='zcld' value='1bb1b38789cb8a3f' />
							<input type='hidden' id='zctd' name='zctd' value='1bb1b38789466029' />
							<input type='hidden' id='document_domain' value='' />
							<input type='hidden' id='zc_Url' value='bpxez-zgph.maillist-manage.net' />
							<input type='hidden' id='new_optin_response_in' value='0' />
							<input type='hidden' id='duplicate_optin_response_in' value='0' />
							<input
								type='hidden'
								id='zc_formIx'
								name='zc_formIx'
								value='3z7dbb597274bb0130518cc92b8e91fd960571b2d4311faa1119821b64da2561af'
							/>
						</div>
						<input type='hidden' id='scriptless' name='scriptless' value='yes' />
						<input type='hidden' id='zc_spmSubmit' name='zc_spmSubmit' value='ZCSPMSUBMIT' />
					</form> */}
				</div>
			</div>
			<VideoModal
				modal={openModal}
				url='https://youtu.be/46I8EI8-On0'
				handlerClose={handlerClose}
			/>
		</section>
	);
};

export default HeaderForm;
